import { characterImagePublicUrl, matchingImageFile } from "./character-image";
import type { CompiledChapter } from "./schema/compiled";

/** Portraits and minor marks follow the files now, whenever the bundle was compiled. */
export function attachPortraits(
  chapter: CompiledChapter,
  fileNames: readonly string[],
  minorIds?: readonly string[],
  /** Full addresses by file name, when portraits are not served beside the app. */
  urls?: Readonly<Record<string, string>>,
): CompiledChapter {
  const urlFor = (characterId: string, appearanceId?: string): string | undefined => {
    const file = matchingImageFile(fileNames, characterId, appearanceId);
    return file === undefined
      ? undefined
      : urls?.[file] ?? characterImagePublicUrl(chapter.bookId, file);
  };
  return {
    ...chapter,
    characters: chapter.characters.map((character) => ({
      ...character,
      imageUrl: urlFor(character.flashbackOf ?? character.id),
      minor: minorIds === undefined
        ? character.minor
        : minorIds.includes(character.flashbackOf ?? character.id) || undefined,
      appearances: character.appearances.map((appearance) => ({
        ...appearance,
        imageUrl: urlFor(character.flashbackOf ?? character.id, appearance.id),
      })),
    })),
  };
}
